import { BaseState } from '@/store/base-state';
import { Reports } from '@/modules/reports/types';
import { TableOptions } from '@/types';

export default class ReportsMutualsState extends BaseState {
  mutuals: Reports.Mutual[] = [];
  organizations: Reports.Organization[]= [];
  external_organizations: Reports.ExternalOrganization[] = [];
  contracts: Reports.Contract[] = [];
  is_download = false;
  is_download_loading = false;
  loading = false;

  debt_info: Reports.MutualsDebtInfo = {
    dates: '',
    total_price: 0,
    total_amount: 0,
    total_shipment_amount: 0,
    amount_of_debt: 0,
  };

  filters: Reports.MutualsReportsFilters = {
    date: null,
    organization_ids: null,
    external_organizations: null,
    contracts: null,
    is_overdue_debt: false,
  };

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['number_days_delay'],
    sortDesc: [true],
  };

  show_tables = false;
}
